<template>
  <div id="kubota">
    <!-- <vs-navbar
      v-model="indexActive"
      class="topnavbar"
      back
      text-color="red"
      color="#FFFFFF"
      active-text-color="red"
    >
      <div slot="title" class="themelogo">
        <img
          src="@/assets/images/kubota/LOGO KUBOTA 2018 (2).png"
          alt="Dashboard"
          width="200px"
        />
      </div>
      <div></div>
    </vs-navbar> -->

    <nav style="position: fixed; background: #fff; width: 100%">
      <div slot="title" class="nav_logo">
        <img
          src="@/assets/images/kubota/LOGO KUBOTA 2018 (2).png"
          alt="Dashboard"
          width="200px"
        />
      </div>
    </nav>
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.nav_logo {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 700px) {
  .nav_logo {
    justify-content: center;
    padding-top: 4px;
  }
}
</style>